import { apiClient } from "../../config";
import { env } from "../../../config/env";
import { GetRolesResponse } from "../../interface/roles.interface";

class AdminRolesService {
  /**
   * 📌 GET ALL ROLES
   */
  async getRoles(): Promise<GetRolesResponse> {
    const response = await apiClient.get<GetRolesResponse>(
      env.ROLES.ADMIN
    );

    return response.data;
  }
}

export const adminRolesService = new AdminRolesService();